module.exports = __webpack_public_path__ + "static/media/type-f.a5c318fb.png";